import { BaseModel } from "sjs-base-model";
export default class RichiestaAltriPrestitiRequestModel extends BaseModel {
    public readonly fgAltriImpegni: boolean = false;
    public readonly codTipoRichiedente: string = "";
    public readonly idRichiesta?: number = 0;
    public readonly isSospensione?: boolean = false;
    public readonly step?: string = "";
    public readonly fgEstinzioneTerzi: boolean = false;
    public readonly isSupera: boolean = false
    public readonly isNonSupera: boolean = false
    //public readonly preventivoQuestionario: PreventivoQuestionarioModel = new PreventivoQuestionarioModel({});

    constructor(data: Partial<RichiestaAltriPrestitiRequestModel>) {
        super();

        this.update(data);
    }
}
